/* eslint
    no-unused-expressions: "warn"
*/

import { elements, globalEvent } from '@shared/easyfy.core';
import { removeCss, showAll, hideAll, toggleClass, visible } from '@shared/easyfy.utils';

export default class Toggle {
  static Instance: Toggle;

  static Event: string;

  constructor(event: string) {
    Toggle.Instance = this;
    Toggle.Event = event;

    globalEvent({
      type: 'click',
      events: [
        {
          callback: e => {
            Toggle.Instance.hideToggle(e?.target);
          },
        },
        {
          event: Toggle.Event,
          callback: this.onToggleElement,
        },
      ],
    });
  }

  onToggleElement(e: any, hide: boolean) {

    if (e?.preventDefault) {
      e.preventDefault();
    }
    if (e.target) {
      e = e.target;
    }

    let target = e.attributes['data-target']?.value;
    if (!target) {
      e = e.parentNode as HTMLElement;
      target = e.attributes['data-target']?.value;
    }

    if (!target) {
      return false;
    }

    const targetElement = document.querySelectorAll<HTMLElement>(`[data-container="${target}"]`);
    const displayType: string = (e.attributes['data-displaytype']?.value as string) ?? 'block';
    const toggleClassName: string = e.attributes['data-toggleClassName']?.value;
    const hiddenValue: string = e.attributes['data-hidden-value']?.value;

    if (!hide) {
      Toggle.Instance.hideToggle(e);
    }

    targetElement.forEach((item) => {
      Toggle.ToggleOverlayVisibility(item);

      visible(item) ? hideAll([item]) : showAll([item], displayType);

      if (toggleClassName) {
        hide && visible(e) ? removeCss(e, toggleClassName) : toggleClass(e, toggleClassName);
      }

      if (hiddenValue) {
        const hiddenInput: HTMLInputElement = item.querySelector('[data-hidden-value]');
        if (hiddenInput) {
          hiddenInput.value = hiddenValue;
        }
        const form: HTMLElement = item.querySelector('[data-action="ajax-form"][data-update]');
        if (form) {
          const updateValue = `${form.attributes['data-update']?.value}-${hiddenValue}`;
          form.setAttribute('data-update', updateValue);
        }
      }
    });

    return false;
  }

  static ToggleOverlayVisibility(item: HTMLElement) {

    try {
      if (item.attributes['data-overlay']) {
        let overlay = document.querySelector<HTMLElement>('[data-overlay-container]');
        if (!visible(item)) {
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.setAttribute('data-overlay-container', '');
            overlay.classList.add('backdrop');
            document.body.appendChild(overlay);
          }
          overlay.classList.remove('backdrop-content', 'backdrop-page');
          overlay.classList.add('backdrop-page', 'backdrop-active');
        } else {
          overlay?.classList.remove('backdrop-active', 'backdrop-page');
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  hideToggle(target: any) {

    const toggleElements: NodeListOf<HTMLElement> = elements(`[data-event="${Toggle.Event}"]`);
    const toggleDropdowns: NodeListOf<HTMLElement> = elements(`[data-container="custom-select"]`);

    toggleElements.forEach((el) => {
      const dataTarget = el.attributes['data-target']?.value;

      const dataTargetElement: NodeListOf<HTMLElement> = document.querySelectorAll<any>(`[data-container="${dataTarget}"]`);
      dataTargetElement.forEach((item) => {
        if (!el.contains(target) && visible(item) && visible(el) && !item.contains(target) && el !== target) {
          this.onToggleElement(el, true);
        }
      });
    });

    toggleDropdowns.forEach((el) => {
      if (!el.contains(target) && el !== target) {
        removeCss(el, 'open');
      }
    });
  }
}
